export default {
  'base.adminUser.title': 'User Management',
  'base.adminUser.colId': 'ID',
  'base.adminUser.colUsername': 'Username',
  'base.adminUser.colAvatar': 'Avatar',
  'base.adminUser.colEmail': 'Email',
  'base.adminUser.colRole': 'Role',
  'base.adminUser.colStatus': 'Status',
  'base.adminUser.colCreatedAt': 'Created At',
  'base.adminUser.colCredit': 'Credits',
  'base.adminUser.adjustCredit': 'Adjust',
  'base.adminUser.colAction': 'Actions',
  'base.adminUser.searchPlaceholder': 'Search username / email',
  'base.adminUser.empty': 'No users',
  'base.adminUser.total': '{total} total',
  'base.adminUser.deleteSuccess': 'Deleted',
  'base.adminUser.deleteFailed': 'Delete failed',
  'base.adminUser.roleAdmin': 'Admin',
  'base.adminUser.roleUser': 'User',
  'base.adminUser.statusNormal': 'Active',
  'base.adminUser.statusDisabled': 'Disabled',
  'base.adminUser.confirmDelete': 'Are you sure you want to delete this user?',

  'base.adminUserModal.titleEdit': 'Edit User',
  'base.adminUserModal.titleAdd': 'Add User',
  'base.adminUserModal.avatarLabel': 'Avatar',
  'base.adminUserModal.avatarUpload': 'Upload',
  'base.adminUserModal.avatarReset': 'Restore default',
  'base.adminUserModal.avatarResetTitle': 'Restore default avatar',
  'base.adminUserModal.avatarResetDesc': 'This removes the current avatar and restores the default one. Continue?',
  'base.adminUserModal.avatarUploadSuccess': 'Avatar uploaded',
  'base.adminUserModal.avatarUploadFailed': 'Avatar upload failed',
  'base.adminUserModal.usernameLabel': 'Username',
  'base.adminUserModal.usernamePlaceholder': 'Please enter username',
  'base.adminUserModal.usernameRequired': 'Please enter username',
  'base.adminUserModal.passwordLabelEdit': 'Password (leave blank to keep unchanged)',
  'base.adminUserModal.passwordLabel': 'Password',
  'base.adminUserModal.passwordPlaceholder': 'At least 6 characters',
  'base.adminUserModal.passwordMin': 'Password must be at least 6 characters',
  'base.adminUserModal.emailLabel': 'Email',
  'base.adminUserModal.emailPlaceholder': 'Optional, used for password recovery',
  'base.adminUserModal.roleLabel': 'Role',
  'base.adminUserModal.roleUser': 'Regular user',
  'base.adminUserModal.roleAdmin': 'Admin',
  'base.adminUserModal.statusLabel': 'Status',
  'base.adminUserModal.saveSuccess': 'Saved',
  'base.adminUserModal.saveFailed': 'Save failed',

  'base.adminRegister.title': 'Registration & Login',
  'base.adminRegister.sectionTitle': 'Registration Settings',
  'base.adminRegister.enableLabel': 'Enable registration',
  'base.adminRegister.enableDesc':
    'When enabled, a "Sign up" entry appears on the login page, allowing visitors to self-register regular accounts.',
  'base.adminRegister.requireEmailLabel': 'Require email for registration',
  'base.adminRegister.requireEmailDesc':
    'When enabled, registration requires an email verified with an email code. SMTP must be configured first. Disabled by default.',
  'base.adminRegister.requirePhoneLabel': 'Require phone for registration',
  'base.adminRegister.requirePhoneDesc':
    'When enabled, registration requires a phone number verified with an SMS code. SMS must be configured first. Disabled by default.',
  'base.adminRegister.needEmailCodeSmtpHint':
    'SMTP is not configured yet. Configure it in "Settings - Mail" before enabling.',
  'base.adminRegister.needPhoneSmsHint':
    'SMS is not configured yet. Configure it in "Settings - SMS" before enabling.',
  'base.adminRegister.saved': 'Saved',
  'base.adminRegister.saveFailed': 'Save failed',

  'base.adminAgreement.userTitle': 'User Agreement',
  'base.adminAgreement.privacyTitle': 'Privacy Policy',
  'base.adminAgreement.userPlaceholder': 'Enter the user agreement content (Markdown)',
  'base.adminAgreement.privacyPlaceholder': 'Enter the privacy policy content (Markdown)',
  'base.adminAgreement.insertExample': 'Insert example',
  'base.adminAgreement.exampleConfirmTitle': 'Insert example document',
  'base.adminAgreement.exampleConfirmDesc': 'The editor already has content. Inserting the example will overwrite it. Continue?',
  'base.adminAgreement.exampleOverwrite': 'Overwrite',
  'base.adminAgreement.exampleInserted': 'Example document inserted',
  'base.adminAgreement.saved': 'Saved',
  'base.adminAgreement.saveFailed': 'Save failed',

  'base.adminPay.title': 'Payment Settings',
  'base.adminPay.alipay': 'Alipay',
  'base.adminPay.wechat': 'WeChat Pay',
  'base.adminPay.connect': 'ModStart Connect (aggregated)',
  'base.adminPay.appId': 'AppId',
  'base.adminPay.privateKey': 'Application private key (RSA2)',
  'base.adminPay.alipayPublicKey': 'Alipay public key',
  'base.adminPay.mchId': 'Merchant ID (MchId)',
  'base.adminPay.apiKey': 'API Key',
  'base.adminPay.serverUrl': 'Server URL',
  'base.adminPay.serverUrlPlaceholder': 'https://connect.tecmz.com',
  'base.adminPay.connectTest': 'Test connection',
  'base.adminPay.connectTestSuccess': 'Connected',
  'base.adminPay.connectTestFailed': 'Connection failed',
  'base.adminPay.connectAppId': 'AppId',
  'base.adminPay.appSecret': 'AppSecret',
  'base.adminPay.connectCallbackHint': 'Payment callbacks use the site access URL in Settings - Basic. Make sure it is publicly reachable.',
  'base.adminPay.saved': 'Saved',
  'base.adminPay.saveFailed': 'Save failed',
  'base.adminPay.rechargeAgreementTitle': 'Recharge Service Agreement',
  'base.adminPay.rechargeAgreementPlaceholder': 'Enter the recharge service agreement content (Markdown), shown on the user recharge screen once configured',

  'base.adminPackage.title': 'Credit Packages',
  'base.adminPackage.addTitle': 'Add Package',
  'base.adminPackage.editTitle': 'Edit Package',
  'base.adminPackage.colId': 'ID',
  'base.adminPackage.colTitle': 'Title',
  'base.adminPackage.colMarketPrice': 'Market Price (CNY)',
  'base.adminPackage.colPayPrice': 'Pay Price (CNY)',
  'base.adminPackage.colCredit': 'Credits',
  'base.adminPackage.colBonus': 'Bonus',
  'base.adminPackage.colSort': 'Sort',
  'base.adminPackage.colEnable': 'Status',
  'base.adminPackage.colDescription': 'Description',
  'base.adminPackage.colAction': 'Actions',
  'base.adminPackage.enabled': 'Enabled',
  'base.adminPackage.disabled': 'Disabled',
  'base.adminPackage.empty': 'No packages',
  'base.adminPackage.titlePlaceholder': 'e.g. Standard',
  'base.adminPackage.titleRequired': 'Please enter a title',
  'base.adminPackage.confirmDelete': 'Delete this package?',
  'base.adminPackage.deleteSuccess': 'Deleted',
  'base.adminPackage.deleteFailed': 'Delete failed',
  'base.adminPackage.saveSuccess': 'Saved',
  'base.adminPackage.saveFailed': 'Save failed',

  'base.adminOrder.title': 'Credit Purchase Records',
  'base.adminOrder.colOrderNo': 'Order No.',
  'base.adminOrder.colUser': 'User',
  'base.adminOrder.colTitle': 'Package',
  'base.adminOrder.colPrice': 'Amount',
  'base.adminOrder.colRefundAmount': 'Refunded',
  'base.adminOrder.colCredit': 'Credits',
  'base.adminOrder.colPayType': 'Method',
  'base.adminOrder.colStatus': 'Status',
  'base.adminOrder.colCreatedAt': 'Time',
  'base.adminOrder.colAction': 'Actions',
  'base.adminOrder.statusAll': 'All statuses',
  'base.adminOrder.statusNew': 'Pending',
  'base.adminOrder.statusPayed': 'Paid',
  'base.adminOrder.statusClosed': 'Closed',
  'base.adminOrder.statusRefunded': 'Refunded',
  'base.adminOrder.statusPartRefunded': 'Partially refunded',
  'base.adminOrder.refund': 'Refund',
  'base.adminOrder.searchPlaceholder': 'Search order no. / user',
  'base.adminOrder.empty': 'No orders',
  'base.adminOrder.actionFailed': 'Action failed',

  'base.adminOrderRefund.title': 'Refund order',
  'base.adminOrderRefund.orderPrice': 'Order amount',
  'base.adminOrderRefund.refunded': 'Refunded',
  'base.adminOrderRefund.refundable': 'Refundable',
  'base.adminOrderRefund.amount': 'Refund amount',
  'base.adminOrderRefund.fillFull': 'Full refund',
  'base.adminOrderRefund.remark': 'Remark',
  'base.adminOrderRefund.remarkPlaceholder': 'e.g. user requested a partial refund',
  'base.adminOrderRefund.notice': 'The system only records the refund status and amount: it neither deducts user credits nor issues the channel refund. Please complete the refund in the Alipay / WeChat merchant console. To deduct credits, ',
  'base.adminOrderRefund.adjustCredit': 'adjust credits',
  'base.adminOrderRefund.tradeNo': 'Channel refund no.',
  'base.adminOrderRefund.tradeNoPlaceholder': 'Fill in after refunding in the channel console',
  'base.adminOrderRefund.tradeNoHint': 'The channel refund number is for reconciliation only and can be filled in later.',
  'base.adminOrderRefund.tradeNoRequired': 'Please enter the channel refund number',
  'base.adminOrderRefund.tradeNoSuccess': 'Refund number saved',
  'base.adminOrderRefund.saveTradeNo': 'Save number',
  'base.adminOrderRefund.submit': 'Confirm refund',
  'base.adminOrderRefund.success': 'Refund recorded, please complete it in the channel console',
  'base.adminOrderRefund.amountInvalid': 'Invalid refund amount: it must be greater than 0 and within the refundable amount',
  'base.adminOrderRefund.failed': 'Refund failed',

  'base.adminUserCredit.title': 'Adjust Credits',
  'base.adminUserCredit.userLabel': 'Username',
  'base.adminUserCredit.creditLabel': 'Current Credits',
  'base.adminUserCredit.direction': 'Direction',
  'base.adminUserCredit.add': 'Add',
  'base.adminUserCredit.sub': 'Subtract',
  'base.adminUserCredit.amount': 'Amount',
  'base.adminUserCredit.remark': 'Remark',
  'base.adminUserCredit.remarkPlaceholder': 'Optional, e.g. campaign bonus',
  'base.adminUserCredit.amountRequired': 'Please enter an amount greater than 0',
  'base.adminUserCredit.saveSuccess': 'Adjusted',
  'base.adminUserCredit.saveFailed': 'Adjust failed',

  'base.adminSetting.title': 'Feature Settings',
  'base.adminSetting.creditLabel': 'Enable Credits',
  'base.adminSetting.creditDesc':
    'When enabled, credit-related menus and pages (credit packages, credit purchases, user credits, recharge) become visible.',
  'base.adminSetting.saved': 'Saved',
  'base.adminSetting.saveFailed': 'Save failed',

  'base.adminNotify.title': 'Operation Notifications',
  'base.adminNotify.emailsTitle': 'Notification Emails',
  'base.adminNotify.emailsDesc': 'When a notification event occurs, an alert email is sent to these addresses.',
  'base.adminNotify.emailsPlaceholder': 'ops@example.com, admin@example.com',
  'base.adminNotify.emailsHint': 'Separate multiple addresses with commas. Configure SMTP in Settings - Email first.',
  'base.adminNotify.eventsTitle': 'Notification Events',
  'base.adminNotify.eventsDesc': 'When enabled, an email is sent each time the business event occurs.',
  'base.adminNotify.creditRecharge': 'User Recharge',
  'base.adminNotify.creditRechargeDesc': 'Notify when a user completes a credit recharge.',
  'base.adminNotify.saved': 'Saved',
  'base.adminNotify.saveFailed': 'Save failed',

  // Channel analytics (registration attribution)
  'base.adminAttr.title': 'Channel Analytics',
  'base.adminAttr.modeFirst': 'First touch',
  'base.adminAttr.modeLast': 'Last touch',
  'base.adminAttr.dateRange': 'Register date',
  'base.adminAttr.summaryTotal': 'Registrations',
  'base.adminAttr.summaryAttributed': 'Attributed',
  'base.adminAttr.summaryUnknown': 'Unattributed',
  'base.adminAttr.summaryUnknownRate': 'Unattributed rate',
  'base.adminAttr.summaryVisits': 'Visitors',
  'base.adminAttr.channelTitle': 'Channel performance',
  'base.adminAttr.colChannel': 'Channel',
  'base.adminAttr.colVisits': 'Visitors',
  'base.adminAttr.colRegisters': 'Registrations',
  'base.adminAttr.colRate': 'Conv. rate',
  'base.adminAttr.colShare': 'Share',
  'base.adminAttr.dimensionTitle': 'Source breakdown',
  'base.adminAttr.tabSource': 'Source',
  'base.adminAttr.tabCampaign': 'Campaign',
  'base.adminAttr.tabLanding': 'Landing page',
  'base.adminAttr.colValue': 'Name',
  'base.adminAttr.trendTitle': 'Registration trend',
  'base.adminAttr.trendSeries': 'Registrations',
  'base.adminAttr.trendEmpty': 'No registration data',
  'base.adminAttr.detailTitle': 'Attribution details',
  'base.adminAttr.colUserId': 'User ID',
  'base.adminAttr.colUsername': 'Username',
  'base.adminAttr.colSource': 'Source',
  'base.adminAttr.colMedium': 'Medium',
  'base.adminAttr.colCampaign': 'Campaign',
  'base.adminAttr.colLanding': 'Landing page',
  'base.adminAttr.colReferrer': 'Referrer host',
  'base.adminAttr.colRegisterDate': 'Register date',
  'base.adminAttr.colRegisterAt': 'Registered at',
  'base.adminAttr.colAction': 'Actions',
  'base.adminAttr.viewDetail': 'View',
  'base.adminAttr.detailModalTitle': 'Attribution detail',
  'base.adminAttr.detailFirst': 'First touch',
  'base.adminAttr.detailLast': 'Last touch',
  'base.adminAttr.detailDevice': 'Device ID',
  'base.adminAttr.detailQuery': 'Landing query',
  'base.adminAttr.detailInvite': 'Inviter',
  'base.adminAttr.detailEmpty': 'No attribution records',
  'base.adminAttr.searchPlaceholder': 'Search username',
  'base.adminAttr.channelCodeTitle': 'Channel codes',
  'base.adminAttr.channelCodeHint': 'Append ch=<code> to campaign links; registrations are grouped into the mapped channel.',
  'base.adminAttr.colCode': 'Code',
  'base.adminAttr.colName': 'Name',
  'base.adminAttr.colChannelType': 'Channel',
  'base.adminAttr.colRemark': 'Remark',
  'base.adminAttr.colEnabled': 'Status',
  'base.adminAttr.colSort': 'Sort',
  'base.adminAttr.enabled': 'Enabled',
  'base.adminAttr.disabled': 'Disabled',
  'base.adminAttr.emptyChannels': 'No channel codes',
  'base.adminAttr.codePlaceholder': 'e.g. douyin_ads',
  'base.adminAttr.namePlaceholder': 'e.g. Douyin feed',
  'base.adminAttr.codeRequired': 'Please enter channel code',
  'base.adminAttr.nameRequired': 'Please enter name',
  'base.adminAttr.channelRequired': 'Please select channel',
  'base.adminAttr.saveSuccess': 'Saved',
  'base.adminAttr.saveFailed': 'Save failed',
  'base.adminAttr.deleteSuccess': 'Deleted',
  'base.adminAttr.deleteFailed': 'Delete failed',
  'base.adminAttr.deleteTitle': 'Delete channel code',
  'base.adminAttr.deleteConfirm': 'Delete this channel code? Existing attribution data is kept.',
  'base.adminAttr.modalAdd': 'Add channel code',
  'base.adminAttr.modalEdit': 'Edit channel code',
}
